
import { getAvatarByKey, getAvatarGenderList, getAvatarList } from "../utils/avatars";
import { getClients } from "./api";
import { getSessions, serverToClientSession } from "./sessionApi";

const avatarsAll = getAvatarList();
const avatarsM = getAvatarGenderList('male');
const avatarsF = getAvatarGenderList('female');
const avatars = {
    'male' : avatarsM,
    'female' : avatarsF,
    '': avatarsAll,
    'other': avatarsAll
}
console.log(avatars)

const getAvatarByNameHash = (name:string, gender: 'male' | 'female' | '' = '') =>{
    const hash = name
        .split('')
        .reduce((ac, it)=>((it.charCodeAt(0) + ac) % avatars[gender].length), 0);
    const key = avatars[gender][hash]
    return getAvatarByKey(key)
}

export const loadClients = ()=>{
    return getClients().then((res)=>res.json()).then(_clients=>{
        //console.log(res);
        return getSessions().then(res=>res.json()).then(_sessions=>{
            let sessionsArray: any[];
            if (Array.isArray(_sessions)) {
                sessionsArray = _sessions;
            } else if (_sessions && typeof _sessions === 'object') {
                const reservedKeys = ['message', 'error', 'status', 'success', 'code', 'Error', 'Message'];
                sessionsArray = Object.entries(_sessions)
                    .filter(([id]) => !reservedKeys.includes(id))
                    .map(([id, data]) => ({ [id]: data }));
            } else {
                sessionsArray = [];
            }
            const sess = sessionsArray.map((it: any)=>{
                const id = Object.keys(it)[0];
                const data = it[id];
                return serverToClientSession({
                    ...data,
                    id
                })
            });
            const results = _clients.map((it: any)=>{
                const id = Object.keys(it)[0];
                const data = it[id];
                //console.log(sess);
                return {
                    waitLoading: false,
                    name: data.Name + ' ' + data.Soname,
                    firstName: data.Name,
                    lastName: data.Soname,

                    gender: data.gender,
                    email: data.email,
                    dateOfBirth: data.dateOfBirth,
                    notes: data.notes,
                    scheduleDay: data.scheduleDay,
                    customAvatarUrl: data.customAvatarUrl,

                    id: id,
                    avatarUrl: data.customAvatarUrl || getAvatarByNameHash(id, data.gender || ''),
                    //@ts-ignore
                    tasks: [],
                    //@ts-ignore
                    sessions: sess.filter(jt => jt.client == id),
                    //@ts-ignore
                    folders: [],

                    // Cache start and end time of the most recent session
                    cachedDate1: (() => {
                        const clientSessions = sess.filter((s: any)=>s.client == id);
                        if (clientSessions.length > 0) {
                            const sortedSessions = [...clientSessions].sort((a, b) =>
                                new Date(b.startDatetime || b.date).getTime() - new Date(a.startDatetime || a.date).getTime()
                            );
                            return sortedSessions[0]?.startDatetime || sortedSessions[0]?.date || '';
                        }
                        return '';
                    })(),
                    cachedDate2: (() => {
                        const clientSessions = sess.filter((s: any)=>s.client == id);
                        if (clientSessions.length > 0) {
                            const sortedSessions = [...clientSessions].sort((a, b) =>
                                new Date(b.startDatetime || b.date).getTime() - new Date(a.startDatetime || a.date).getTime()
                            );
                            return sortedSessions[0]?.endDatetime || sortedSessions[0]?.dateTo || '';
                        }
                        return '';
                    })()
                }
            });
            console.log(results);
            return results;
            //setClientsData(results);
        });
    });
}

export const loadClientsRaw = ()=>{
    return getClients().then((res)=>res.json()).then(_clients=>{
        const results = _clients.map((it: any)=>{
            const id = Object.keys(it)[0];
            const data = it[id];
            
            // Load cached dates from localStorage
            const cacheKey = `client_dates_${id}`;
            const cachedDates = localStorage.getItem(cacheKey);
            let cachedDate1 = '';
            let cachedDate2 = '';
            
            if (cachedDates) {
                try {
                    const parsed = JSON.parse(cachedDates);
                    cachedDate1 = parsed.date1 || '';
                    cachedDate2 = parsed.date2 || '';
                } catch (e) {
                    // Invalid cache, ignore
                }
            }
            
            return {
                waitLoading: false,
                name: data.Name + ' ' + data.Soname,
                firstName: data.Name,
                lastName: data.Soname,

                gender: data.gender,
                email: data.email,
                dateOfBirth: data.dateOfBirth,
                notes: data.notes,
                scheduleDay: data.scheduleDay,
                customAvatarUrl: data.customAvatarUrl,

                id: id,
                avatarUrl: data.customAvatarUrl || getAvatarByNameHash(id, data.gender || ''),
                //@ts-ignore
                tasks: [],
                //@ts-ignore
                folders: [],
                
                // Load cached dates from localStorage
                cachedDate1,
                cachedDate2
            }
        });
        return results;
    });
}

export const loadSessionsForClient = (clientId:string)=>{
    return getSessions(clientId).then(res=>res.json()).then(_sessions=>{
        let sessionsArray: any[];
        if (Array.isArray(_sessions)) {
            sessionsArray = _sessions;
        } else if (_sessions && typeof _sessions === 'object') {
            const reservedKeys = ['message', 'error', 'status', 'success', 'code', 'Error', 'Message'];
            sessionsArray = Object.entries(_sessions)
                .filter(([id]) => !reservedKeys.includes(id))
                .map(([id, data]) => ({ [id]: data }));
        } else {
            sessionsArray = [];
        }
        const session = sessionsArray.map((it: any)=>{
            const id = Object.keys(it)[0];
            const data = it[id];
            return serverToClientSession({
                ...data,
                id
            })
        })
        return session
    });
}
